import(/* webpackMode: "eager" */ "/vercel/path0/src/app/detailing/page.tsx");
